<template>
  <div
    v-if="
      user &&
      ([
        'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
        'DIRECTIVOS ACADÉMICOS (CAMPUS)',
        'DIRECTIVOS FACULTAD O ESCUELA',
        'DIRECTORES DE CARRERA',
        'DIRECTORES DE CARRERA (CAMPUS)',
        'ADMINISTRATIVOS INSTRUCCIONALES',
        'PROFESORES',
      ].some((group) => user.group_names.includes(group)) ||
        user.is_superuser)
    "
  >
    <template
      v-if="
        show_button_ai &&
        allows_crud &&
        user &&
        (user.user_data == null ||
          (user.user_data && user.user_data.ai_component))
      "
    >
      <b-button
        v-b-toggle.sidebar-right
        class="new-btn-ai noprint"
        title="IA"
        :class="{ 'kl-rail--expanded': expanded }"
      >
        <img src="../../../assets/icon-ai.svg" alt="" class="new-icon-btn-ai" />
        <span v-if="expanded == true" class="ai-text ml-2">
          {{ $t("reusable.aiComponent.artificialIntelligence") }}
        </span>
      </b-button>
    </template>

    <AiSidebar></AiSidebar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as names from "@/store/names";

export default {
  name: "NewAiComponent",
  components: {
    AiSidebar: () => import("@/components/reusable/ai-component/AiSidebar"),
  },
  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show_button_ai: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      show_intelligence_sidebar: names.SHOW_INTELLIGENCE_SIDEBAR,
      allows_crud: names.ALLOWS_CRUD,
    }),
  },
  methods: {},
  watch: {
    show_intelligence_sidebar(value) {
      this.show_button_ai = value;
    },
  },
  mounted() {},
  created() {
    if (this.show_intelligence_sidebar == true) {
      this.show_button_ai = this.show_intelligence_sidebar;
      this.$store.dispatch(names.FETCH_EGRESS_PROFILES);
    }
  },
};
</script>

<style scoped>
.new-btn-ai {
  --rail-width: 60px;
  --rail-width-expanded: 248px;
  width: var(--rail-width);
  background-color: var(--kl-fourth-hover-color) !important;
  border: none !important;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70px;
}
.new-btn-ai:hover {
  background-color: var(--kl-fourth-hover-color) !important;
  opacity: 0.9;
}
.new-icon-btn-ai {
  width: 34px;
  height: 34px;
  color: #000 !important;
}
.kl-rail--expanded {
  width: var(--rail-width-expanded);
}
.ai-text {
  color: white;
}
.new-btn-ai.kl-rail--expanded {
  width: 100%;
}
.btn-ai {
  position: fixed;
  right: 5vw;
  bottom: 0.3vh;
  z-index: 1050;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  background-color: var(--kl-fourth-hover-color) !important;
  color: white;
  font-size: 1.2rem;
  font-weight: bold;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  border: 1px solid var(--kl-fourth-hover-color) !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-ai:hover {
  background-color: var(--kl-fourth-hover-color) !important;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3);
  transform: scale(1.05);
}
.icon-btn-ai {
  width: 40px;
  height: 40px;
}

/* Media Querys */
@media only screen and (max-width: 1300px) {
  .btn-ai {
    right: 6.5vw;
  }
}

@media only screen and (max-width: 1100px) {
  .btn-ai {
    right: 7.5vw;
  }
}

@media only screen and (max-width: 900px) {
  .btn-ai {
    right: 9vw;
  }
}
@media only screen and (max-width: 700px) {
  .btn-ai {
    display: none;
  }
}
@media only screen and (max-width: 620px) {
  .btn-ai {
    display: none;
  }
}
</style>